import { convertDateTime } from 'utils/helpers';

import { convertToCurrency, convertNumberBR, convertDate } from 'xpi-black-ui/Utils/helpers';

import uuidv4 from 'uuidv4';

export const normalizeTradeIdeaOperations = operations => (
  operations.tradeIdeas.map(value => ({
    ...value,
    operacaoId: value.id.toString(),
    vencimento: value.dataFixing,
    pctComissao: value.percentualComissaoTotal,
    tipoEstrategia: value.estrutura,
  })));

export const normalizeOperatidons = proposals => (
  proposals.map(proposal => ({
    ...proposal,
    id: uuidv4(),
    comissaoNumerico: proposal.comissao,
    vencimento: convertDate(proposal.vencimento),
    comissao: convertToCurrency(proposal.comissao),
    precoFinal: convertToCurrency(proposal.precoFinal),
    quantidade: convertNumberBR(proposal.quantidade, 2),
    dataInclusao: convertDateTime(proposal.dataInclusao),
    precoReferencia: convertToCurrency(proposal.precoReferencia),
    status: {
      ...proposal.status,
      color: proposal.status,
      // ? colorStatus(proposal.status.id)
      // : '',
    },
  }))
);
